import type { JSX, ReactNode } from 'react';

interface ErrorStateProps {
  title?: string;
  description?: string;
  action?: ReactNode;
  role?: 'alert' | 'status';
  ariaLive?: 'assertive' | 'polite';
}

export function ErrorState({
  title = 'Something went wrong',
  description = 'We hit a snag while loading this content. Please try again or contact support.',
  action,
  role = 'status',
  ariaLive,
}: ErrorStateProps): JSX.Element {
  const liveRegion = ariaLive ?? (role === 'alert' ? 'assertive' : 'polite');

  return (
    <section
      role={role}
      aria-live={liveRegion}
      className="container flex flex-col items-center justify-center gap-md py-12 text-center"
    >
      <div className="w-full max-w-xl rounded-2xl border border-brand-primary/30 bg-white p-8 shadow-card">
        <h2 className="text-2xl font-semibold text-brand-primary">{title}</h2>
        <p className="mt-sm text-text-primary/80">{description}</p>
        {action !== null && action !== undefined ? (
          <div className="mt-md flex justify-center">{action}</div>
        ) : null}
      </div>
    </section>
  );
}
